import axios from '@/libs/api.request'
import urlObj from '@/config/env.js'

//  买家处理退款处理信息 (前台)
export function buyerfreight(params) {
  return axios.request({
    url: urlObj.wss + `wss-order/sales/after/revoke/${params}`,
    method: 'get'
  })
}

// 退货的接口
export function getapplyForRefund(id) {
  return axios.request({
    url: `${urlObj.wss}wss-order/afterSale/assertions/${id}`,
    method: 'get'
  })
}
// 门店
export function storeName() {
  return axios.request({
    url: urlObj.wss + 'wss-order/myWssOrder/getShopOptions',
    method: 'get'
  })
}
// 主表
export function getSalesOrder(params, data) {
  return axios.request({
    url: urlObj.wss + 'wss-order/myWssOrder/getBuyOrder',
    method: 'post',
    params,
    data
  })
}
// 数据字典
export function getDictionariesItemList(params) {
  return axios.request({
    url: urlObj.crm + 'crm/dictionariesItem/getDictionariesItems',
    method: 'get',
    params
  })
}
// 主表(退款/退货)
export function getSalesReturn(data) {
  return axios.request({
    url: urlObj.wss + 'wss-order/afterSale/listAfterSalesOrder',
    method: 'post',
    data
  })
}
// 取消订单
export function cancelOrder(params) {
  return axios.request({
    url: urlObj.wss + 'wss-order/order/cancelOrder',
    method: 'put',
    params
  })
}

// 收货
export function orderTakeDelivery(params) {
  return axios.request({
    url: `${urlObj.wss}wss-order/order/orderTakeDelivery`,
    method: 'put',
    params
  })
}

// 店铺名称
export function buyshopstate(params) {
  return axios.request({
    url: `${urlObj.wss}wss-order/afterSale/listShopByBusiness`,
    method: 'get',
    params
  })
}

export function revoke(id) {
  return axios.request({
    url: `${urlObj.wss}wss-order/sales/after/revoke/${id}`,
    method: 'get'
  })
}

export function applyForRefund(id) {
  return axios.request({
    url: `${urlObj.wss}wss-order/afterSale/judge/${id}`,
    method: 'get'
  })
}

// 打印
export function print(id) {
  return axios.request({
    url: `${urlObj.wss}wss-order/myWssOrder/printOrder?id=${id}`,
    method: 'get',
  })
}

// 下单员
export function getOrderer(params) {
  return axios.request({
    url: urlObj.crm + 'uims-oauth/employee/orderer',
    method: 'get',
    params
  })
}

